module.exports = __webpack_public_path__ + "static/ECDA-9d89ee8d97e3004ef2aec6fb66d5b328.png";